let authApi = '/api/auth';
let systemApi = '/api/system';
let masterApi = '/api/masters';
let configurationApi = '/api/configuration';
let auditandlogApi = '/api/auditandlogs';
let userApi = '/api/users';
let dashboardApi = '/api/dashboard';
let leadMgmtApi = '/api/leadmanagement';
let subscriptionMgmtApi = '/api/subscriptionmanagement';
let clientManagementApi = '/api/clientmanagement';
let productAndServiceApi = '/api/productandservice';

/*
let enquiryApi = '/api/enquiries';
let productApi = '/api/products';
let subscriptionplanApi = '/api/subscriptionplans';
let subscriptionplanfeatureApi = '/api/subscriptionplanfeatures';
let clientApi = '/api/clients';
let leadApi = '/api/leads';
let demoApi = '/api/demos';
let subscriptionApi = '/api/subscriptions';
let clientcontactApi = '/api/clientcontacts';
let orderApi = '/api/orders';
let productfeatureApi = '/api/productfeatures';
*/

export default {
    auth: {
	loginterms: authApi + '/loginterms',
        login: authApi + '/login', //POST
	refreshToken: authApi + '/refreshtoken', //POST
        logout: authApi + '/logout', //POST
        userfromtoken: authApi + '/userfromtoken',
	privilege: authApi + '/privilege',
	moduleRolePrivilege: authApi + '/moduleroleprivilege',
    },
    system: {
	sideMenu: systemApi + '/sidemenu',
    },
    masters: {
	thermalprinter : masterApi + '/thermalprinter',
	currency : masterApi + '/currency',
	timezone: masterApi + '/timezone',
        country: masterApi + '/country',
        state: masterApi + '/state',
        district: masterApi + '/district',
        city: masterApi + '/city',
        region: masterApi + '/region',
    },
    configuration: {
        organization: configurationApi + '/organization',
        outgoingmail: configurationApi + '/outgoingmail',
        loginterms : configurationApi + '/loginterms',
    },
    auditandlog: {
	audittrail : auditandlogApi + '/audittrail',
	apirequestlog : auditandlogApi + '/apirequestlog',
    },
    users: {
        user: userApi + '/user',
	loginhistory: userApi + '/user/loginhistory',
        userRole: userApi + '/userrole',
        passwordPolicy: userApi + '/passwordpolicy',       
    },
    dashboard: {
	totals : dashboardApi + '/totals',
	latestdevices: dashboardApi + '/latestdevices',
	topclients: dashboardApi + '/topclients',
    },
    leadmanagement: {
	enquiry : leadMgmtApi+'/enquiry',
	demo : leadMgmtApi+'/demo',
	lead : leadMgmtApi+'/lead',
	leadsource : leadMgmtApi+'/leadsource',
	leadstatus : leadMgmtApi+'/leadstatus',
	calllog : leadMgmtApi+'/calllog',
    },
    subscriptionmanagement: {
	subscriptionplan : subscriptionMgmtApi +'/subscriptionplan',
	features : subscriptionMgmtApi +'/subscriptionplan/features',
	subscriptionperiod : subscriptionMgmtApi +'/subscriptionperiod',
	subscription : subscriptionMgmtApi +'/subscription',
	invoice : subscriptionMgmtApi +'/invoice',
	invoiceitem : subscriptionMgmtApi +'/invoiceitem',
	invoicestate : subscriptionMgmtApi +'/invoicestate',
	invoicestatus : subscriptionMgmtApi +'/invoicestatus',
    },
    clientmanagement: {
	  client : clientManagementApi+'/client',
	  contact : clientManagementApi+'/contact',
    },
    productandservice: {
	product : productAndServiceApi+'/product',
	productfeature : productAndServiceApi+'/productfeature',
    }
};
